<template>
    <div id="wrapper">
        <img class="bg" v-if="['100'].includes(this.goodsCode)" src="@/assets/vipGoods/100/1.png" alt="">
        <img class="bg" v-if="['200'].includes(this.goodsCode)" src="@/assets/vipGoods/200/1.png" alt="">
        <img class="bg" v-if="['107'].includes(this.goodsCode)" src="@/assets/vipGoods/107/1.png" alt="">
        <img class="bg" v-if="['223'].includes(this.goodsCode)" src="@/assets/vipGoods/223/1.png" alt="">
        <div class="menu">
            <div class="item" v-for="(v,i) in 12" :key="i" @click="goVipIntroduce(v)"></div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['cityCode', 'goodsCode', 'type'],
    data () {
        return {

        }
    },
    methods: {
        // 跳转权益
        goVipIntroduce (v) {
            let queryData = JSON.parse(JSON.stringify(this.$route.query))
            queryData.id = this.goodsCode
            queryData.type = v
            localStorage.setItem('t-c-goodsCode', this.goodsCode)
            this.$router.push({ name: 'vipIntroduce', query: queryData })
        }
    },
    mounted () {

    }
}
</script>
<style lang="scss" scoped>
#wrapper {
    position: relative;
    .bg{
        width: 100%;
    }
    .menu{
        box-sizing: border-box;
        display: flex;
        padding: 10px;
        flex-wrap: wrap;
        top: 40px;
        left: 5px;
        position: absolute;
        justify-content: space-between;
    }
    .item{
        width: 80px;
        height: 70px;
    }

}
</style>
